export default __webpack_public_path__ + "static/media/sudoku.9c9211ab.jpg";